import React from 'react';
import { Row } from 'antd';

export const Section = (props: any) => {
  return <Row className={`px-5 mb-5 ${props.className || ''}`}>{props.children}</Row>;
};

export const SectionRow = (props: any) => {
  return <Row className={`w-full mb-3 ${props.className || ''}`}>{props.children}</Row>;
};
